import feedPostsApi from "@/api/posts/client";
import { FeedPostCreate } from "@/api/posts/types";
import { MutationArgs } from "@/web3/contracts/common/types";
import { useMutation } from "@tanstack/react-query";
import usePostInvalidation from "./usePostInvalidation";

export default function usePostCreate({ onSuccess, onError }: MutationArgs) {
  const invalidatePosts = usePostInvalidation();

  const { mutateAsync: createPost, isLoading } = useMutation({
    mutationFn: (feedPost: FeedPostCreate) =>
      feedPostsApi.upsertFeedPost(feedPost),
    onSuccess: () => {
      invalidatePosts();
      onSuccess?.();
    },
    onError,
  });

  return { createPost, isLoading };
}
